import { TRANSITION_TYPE } from '../../enums';
import { DipToBlackFadeTransition } from './DipToBlackFadeTransition';
import { CrossFadeTransition } from './CrossFadeTransition';
// import { HeartTransition } from './HeartTransition';

// Sync with player-v2/components/transitions/index.js
export default {
    [TRANSITION_TYPE.DIP_TO_BLACK_FADE]: new DipToBlackFadeTransition(),
    [TRANSITION_TYPE.CROSS_FADE]: new CrossFadeTransition(),
    // [TRANSITION_TYPE.HEART]: new HeartTransition(),
};
